import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "control" }

import VueSelect, { type Option } from "vue3-select-component";
import { snakeCase } from "lodash-es";
import { computed } from "vue";

interface Props {
  label?: string;
  placeholder?: string;
  modelValue?: Option<string | number> | null;
  options: Option<string | number>[];
  grandparentClass?: string;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'static-single-select',
  props: {
    label: {},
    placeholder: { default: "" },
    modelValue: {},
    options: {},
    grandparentClass: { default: "field" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const inputId = computed(() => snakeCase(props.label));

// Extract just the value for modelValue (vue3-select-component expects value, not Option)
const selectedValue = computed(() => props.modelValue?.value ?? null);

// When value changes, look up full Option object and emit
function handleValueChange(value: string | number | (string | number)[] | null | undefined) {
  // vue3-select-component can emit array for some edge cases, handle both
  const singleValue = Array.isArray(value) ? (value[0] ?? null) : (value ?? null);
  if (singleValue === null) {
    emit("update:modelValue", null);
    return;
  }
  const selectedOption = props.options.find((opt) => opt.value === singleValue);
  emit("update:modelValue", selectedOption ?? null);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.grandparentClass)
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: inputId.value,
          class: "label"
        }, _toDisplayString(__props.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(VueSelect), {
        options: __props.options as any,
        isDisabled: __props.disabled,
        placeholder: __props.placeholder,
        inputId: __props.label ? inputId.value : undefined,
        modelValue: selectedValue.value,
        "onUpdate:modelValue": handleValueChange
      }, null, 8, ["options", "isDisabled", "placeholder", "inputId", "modelValue"])
    ])
  ], 2))
}
}

})